module.exports = __webpack_public_path__ + "img/ThatHotelAgain.7c74d798.png";